import _ from 'lodash';

import { id } from '../utils/helper';

export const FETCH_JOBS = 'FETCH_JOBS';
export const FETCHING_JOBS = 'FETCHING_JOBS';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILED = 'FETCH_JOBS_FAILED';

export const FETCH_JOB = 'FETCH_JOB';
export const FETCHING_JOB = 'FETCHING_JOB';
export const FETCH_JOB_SUCCESS = 'FETCH_JOB_SUCCESS';
export const FETCH_JOB_FAILED = 'FETCH_JOB_FAILED';

export const SET_JOB = 'SET_JOB';
export const SET_REFERENCE = 'SET_REFERENCE';
export const SET_JOB_PROFILE = 'SET_JOB_PROFILE';
export const SET_TASK_PROFILES = 'SET_TASK_PROFILES';
export const SET_CUSTOMER = 'SET_JOB_CUSTOMER';
export const SET_PRIMARY_CONTACT = 'SET_PRIMARY_CONTACT';
export const SET_ORIGIN = 'SET_JOB_ORIGIN';
export const SET_DESTINATION = 'SET_JOB_DESTINATION';
export const SET_START = 'SET_JOB_START';
export const SET_END = 'SET_JOB_END';
export const SET_DESCRIPTION = 'SET_JOB_DESCRIPTION';
export const SET_NOTES = 'SET_JOB_NOTES';

export const ADD_TASK_PROFILE = 'ADD_TASK_PROFILE';
export const REMOVE_TASK_PROFILE = 'REMOVE_TASK_PROFILE';

export const ADD_TASK = 'ADD_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';

export const ADD_PREFERRED_ITEM = 'ADD_PREFERRED_ITEM';
export const REMOVE_PREFERRED_ITEM = 'REMOVE_PREFERRED_ITEM';
export const SET_PREFERRED_ITEMS = 'SET_PREFERRED_ITEMS';

export const ADD_TAG = 'ADD_JOB_TAG';
export const REMOVE_TAG = 'REMOVE_JOB_TAG';

export const ADD_RESOURCES = 'ADD_JOB_RESOURCES';
export const ADD_RESOURCE = 'ADD_JOB_RESOURCE';
export const REMOVE_RESOURCE = 'REMOVE_JOB_RESOURCE';

export const SET_RESOURCE_EMPLOYEE = 'SET_RESOURCE_EMPLOYEE';

export const ADD_STAGE = 'ADD_JOB_STAGE';
export const REMOVE_STAGE = 'REMOVE_JOB_STAGE';

// export const SAVE_JOB = 'SAVE_JOB';
// export const SAVING_JOB = 'SAVING_JOB';
// export const SAVE_JOB_SUCCESS = 'SAVE_JOB_SUCCESS';
// export const SAVE_JOB_FAILED = 'SAVE_JOB_FAILED';

export const REMOVE_JOB = 'REMOVE_JOB';

export function setJob(job) {
  console.log('jobId', job ? job.id : null);
  return {
    type: SET_JOB,
    job,
  };
}

export function fetchJobs() {
  return {
    type: FETCH_JOBS,
  };
}

export function fetchingJobs() {
  return {
    type: FETCHING_JOBS,
  };
}

export function fetchJobsSuccess(jobs) {
  return {
    type: FETCH_JOBS_SUCCESS,
    jobs,
  };
}

export function fetchJobsFailed(err) {
  return {
    type: FETCH_JOBS_FAILED,
    message: err.message,
  };
}

export function fetchJob(jobId) {
  return {
    type: FETCH_JOB,
    jobId,
  };
}

export function fetchingJob(jobId) {
  return {
    type: FETCHING_JOB,
    jobId,
  };
}

export function fetchJobSuccess(job) {
  return {
    type: FETCH_JOB_SUCCESS,
    job,
  };
}

export function fetchJobFailed(jobId, err) {
  return {
    type: FETCH_JOB_FAILED,
    jobId,
    message: err.message,
  };
}

export function setReference(job, reference) {
  return {
    type: SET_REFERENCE,
    job,
    reference,
  };
}

export function setCustomer(job, customer) {
  return {
    type: SET_CUSTOMER,
    job,
    customer,
  };
}

export function setPrimaryContact(job, primaryContact) {
  return {
    type: SET_PRIMARY_CONTACT,
    job,
    primaryContact,
  };
}

export function setOrigin(job, origin) {
  return {
    type: SET_ORIGIN,
    job,
    origin,
  };
}

export function setDestination(job, destination) {
  return {
    type: SET_DESTINATION,
    job,
    destination,
  };
}

export function setStart(job, start) {
  return {
    type: SET_START,
    job,
    start,
  };
}

export function setEnd(job, end) {
  return {
    type: SET_END,
    job,
    end,
  };
}

export function setDescription(job, description) {
  return {
    type: SET_DESCRIPTION,
    job,
    description,
  };
}

export function setNotes(job, notes) {
  return {
    type: SET_NOTES,
    job,
    notes,
  };
}

export function setJobProfile(job, jobProfile) {
  return {
    type: SET_JOB_PROFILE,
    job,
    jobProfile,
  };
}

export function setTaskProfiles(job, taskProfiles) {
  return {
    type: SET_TASK_PROFILES,
    job,
    taskProfiles,
  };
}

export function addTaskProfile(job, taskProfile) {
  return {
    type: ADD_TASK_PROFILE,
    job,
    taskProfile,
  };
}

export function removeTaskProfile(job, taskProfile) {
  return {
    type: REMOVE_TASK_PROFILE,
    job,
    taskProfile,
  };
}

export function addPreferredItem(job, itemType) {
  return {
    type: ADD_PREFERRED_ITEM,
    job,
    itemType,
  };
}

export function removePreferredItem(job, itemType) {
  return {
    type: REMOVE_PREFERRED_ITEM,
    job,
    itemType,
  };
}

export function setPreferredItems(job, itemTypes) {
  return {
    type: SET_PREFERRED_ITEMS,
    job,
    itemTypes,
  };
}

export function addTag(job, tag) {
  return {
    type: ADD_TAG,
    job,
    tag,
  };
}

export function removeTag(job, tag) {
  return {
    type: REMOVE_TAG,
    job,
    tag,
  };
}

export function addResources(job, resources) {
  return {
    type: ADD_RESOURCES,
    job,
    resources: resources.map((res) => _.assign({ id: id() }, res)),
  };
}

export function addResource(job, resource) {
  return {
    type: ADD_RESOURCE,
    job,
    resource: _.assign({ id: id() }, resource),
  };
}

export function removeResource(job, resource) {
  return {
    type: REMOVE_RESOURCE,
    job,
    resource,
  };
}

export function setResourceEmployee(job, resource, employee) {
  return {
    type: SET_RESOURCE_EMPLOYEE,
    job,
    resource,
    employee,
  };
}

export function addStage(job, stage) {
  return {
    type: ADD_STAGE,
    job,
    stage,
  };
}

export function removeStage(job, stage) {
  return {
    type: REMOVE_STAGE,
    job,
    stage,
  };
}

export function addTask(job, task) {
  return {
    type: ADD_TASK,
    job,
    task,
  };
}

export function removeTask(job, task) {
  return {
    type: REMOVE_TASK,
    job,
    task,
  };
}

export function removeJob(job) {
  return {
    type: REMOVE_JOB,
    job,
  };
}

// export function addJobTag(job, tag) {
//   return {
//     type: ADD_JOB_TAG,
//     job,
//     tag,
//   };
// }
//
// export function removeJobTag(job, tag) {
//   return {
//     type: REMOVE_JOB_TAG,
//     job,
//     tag,
//   };
// }



// WEBPACK FOOTER //
// ./src/actions/jobs.js